import React from "react";
import { Input } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Input title for convention form.
 */
export const InputConventionTitle = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-convention-title-error",
  };

  const inputProps = {
    type: "text",
    id: "input-convention-title",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "HEADER",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.TITLE,
  };

  return <Input {...parentProps} />;
};
